import WelcomeGiftNotificationFrame from './WelcomeGiftNotificationFrame';

export * from './utils';

export default WelcomeGiftNotificationFrame;
